import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CatalogContentfulBrandsResolver } from "@core/resolver/catalog-contentful-brands.resolver";
import { CatalogContentfulCategoriesResolver } from "@core/resolver/catalog-contentful-categories.resolver";
import { CatalogContentfulHeroResolver } from "@core/resolver/catalog-contentful-hero.resolver";
import { CatalogContentfulProductsResolver } from "@core/resolver/catalog-contentful-products.resolver";
import { CatalogContentfulSubcategoriesResolver } from "@core/resolver/catalog-contentful-subcategories.resolver";
import { CatalogContentfulDesignToolProductsResolver } from "@core/resolver/catalog-contentful-design-tool-products.resolver"
import { ProductAllResolver } from "@core/resolver/product-all.resolver";
import { CatalogHomeComponent } from "@features/catalog/catalog-home/catalog-home.component";
import { CatalogComponent } from "@features/catalog/catalog.component";
import { ProductAllComponent } from "@features/catalog/product-all/product-all.component";
import { ProductDetailComponent } from "@features/catalog/product-detail/product-detail.component";
import { ProductDesignComponent } from "@features/catalog/product-design/product-design.component";
import { GetDesignFilesResolver } from "@core/resolver/get-design-files.resolver";
import { GetProductVariantDesignResolver } from "@core/resolver/get-product-variant-design.resolver";
import { DesignClientResolver } from "@core/resolver/designs-client.resolver";
import { AvalaraCustomerResolver } from "@core/resolver/avalara-customer.resolver";
import { DesignToolMocksResolver } from "@core/resolver/design-tool-mocks.resolver";
import { CatalogProductDetailsResolver } from "@core/resolver/catalog-product-details.resolver";
import { CatalogContentfulFeaturedCollectionsResolver } from "@core/resolver/catalog-contentful-featured-collections.resolver";
import { CatalogContentfulBannerResolver } from "@core/resolver/catalog-contentful-banner.resolver";
import { DesignToolCanvasResolver } from "@core/resolver/design-tool-canvas.resolver";
import { DesignToolAvailableResolver } from "@core/resolver/design-tool-available.resolver";
// import { AuthGuard } from "@auth0/auth0-angular";
import { CatalogHomeResolver } from "@core/resolver/catalog-home.resolver";
import { AuthGuard } from "@core/guards/auth.guard";
import { ContentfulCarouselHeaderResolver } from "@core/resolver/contentful/carousel-header.resolver";
import { ContentfulCategoryGalleryResolver } from "@core/resolver/contentful/category-gallery.resolver";
import { ContentfulKeyFeaturesResolver } from "@core/resolver/contentful/key-features.resolver";
import { ContentfulCallToActionResolver } from "@core/resolver/contentful/call-to-action.resolver";
import { ContentfulFAQResolver } from "@core/resolver/contentful/faq.resolver";


const routes: Routes = [
    {
        path: '',
        component: CatalogComponent,
        children: [
            {
                path: '',
                component: CatalogHomeComponent,
                resolve: {
                    catalogHome: CatalogHomeResolver,
                    contentfulHero: CatalogContentfulHeroResolver,
                    contentfulCategories: CatalogContentfulCategoriesResolver,
                    contentfulProducts: CatalogContentfulProductsResolver,
                    contentfulFeaturedCollections: CatalogContentfulFeaturedCollectionsResolver,
                    contentfulBrands: CatalogContentfulBrandsResolver,
                    contentfulSubcategories: CatalogContentfulSubcategoriesResolver,
                    contentfulDesignToolProducts: CatalogContentfulDesignToolProductsResolver,
                    contentfulBanner: CatalogContentfulBannerResolver,
                    contentfulCarouselHeader: ContentfulCarouselHeaderResolver,
                    contentfulCategoryGallery: ContentfulCategoryGalleryResolver,
                    contentfulKeyFeatures: ContentfulKeyFeaturesResolver,
                    contentfulCallToAction: ContentfulCallToActionResolver,
                    contentfulFAQ: ContentfulFAQResolver
                    
                }
            }, //resolver that will contain data needed for home page
            {
                path: 'all',
                component: ProductAllComponent,
                resolve: {
                    productAll: ProductAllResolver,
                    contentfulHero: CatalogContentfulHeroResolver,
                    contentfulSubcategories: CatalogContentfulSubcategoriesResolver
                }
            },
            {
                path: ':brand/:style',
                component: ProductDetailComponent,
                resolve: {
                    getVariantProduct: GetProductVariantDesignResolver,
                    product: CatalogProductDetailsResolver,
                    designToolMockups: DesignToolMocksResolver,
                    designToolAvailability: DesignToolAvailableResolver
                }
            },
            {
                path: ':brand/:style/customize',
                component: ProductDesignComponent,
                resolve: {
                    getVariantProduct: GetProductVariantDesignResolver,
                    getDesign: GetDesignFilesResolver,
                    clientDesigns: DesignClientResolver,
                    avalaraClient: AvalaraCustomerResolver,
                    designToolMockups: DesignToolMocksResolver,
                    designToolCanvas: DesignToolCanvasResolver
                },
                canActivate: [AuthGuard]
            }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CatalogRoutingModule { }
